import { render, staticRenderFns } from "./FullTaskFilterItem.vue?vue&type=template&id=5d07c9fa&scoped=true"
import script from "./FullTaskFilterItem.vue?vue&type=script&lang=js"
export * from "./FullTaskFilterItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d07c9fa",
  null
  
)

export default component.exports